import React from 'react';
import { ToastContainer } from 'react-toastify';
import AdminChrome from '../../AdminShared/AdminChrome';
import AdminPageHead from '../../AdminShared/AdminPageHead';
import RiskDesk from '../components/RiskDesk';

const RiskDeskApp = ({ mountToast = true, chrome = {}, ...props }) => (
  <AdminChrome {...chrome}>
    <div className="adash-body">
      <AdminPageHead
        title="Risk Desk"
        subtitle="Triage flagged orders and chargebacks — approve, refund, or block before the money moves."
      />
      <RiskDesk {...props} />
    </div>
    {mountToast ? <ToastContainer icon={false} /> : null}
  </AdminChrome>
);

export default RiskDeskApp;
